module.exports = __webpack_public_path__ + "static/media/S1N8.93de4a50.svg";